import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function Pistacchio({ data }) {
  return (
    <section id="pistacchio" data-testid="pistacchio-section" className="bg-[#1E1614] text-[#FAF7F2] py-20 sm:py-28 lg:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
              {data.tag}
            </p>
            <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              {data.title}
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#FAF7F2]/70 max-w-xl">
              {data.text}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-3">
              {data.facts.map((f) => (
                <span
                  key={f}
                  className="font-accent text-[11px] uppercase tracking-[0.14em] border border-[#C39A48]/40 text-[#C39A48] rounded-full px-4 py-2"
                >
                  {f}
                </span>
              ))}
            </div>
            <blockquote className="mt-10 border-l-2 border-[#C86D51] pl-5">
              <p className="font-display italic text-lg sm:text-xl text-[#FAF7F2]/85">{data.quote}</p>
              <a
                href={data.source_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pistacchio-source-link"
                className="mt-3 inline-flex items-center gap-1.5 font-accent text-xs uppercase tracking-[0.18em] text-[#C86D51] hover:text-[#C39A48] transition-colors"
              >
                {data.source_label} · {data.quote_source} <ArrowUpRight size={14} />
              </a>
            </blockquote>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:col-span-6">
          <div className="relative max-w-lg mx-auto lg:ml-auto">
            <div
              aria-hidden="true"
              className="absolute -inset-3 rounded-t-[9rem] rounded-b-3xl border border-[#C39A48]/30"
            />
            <img
              src={data.image}
              alt={data.alt}
              data-testid="pistacchio-image"
              loading="lazy"
              className="w-full aspect-[4/5] sm:aspect-[5/5] object-cover object-top rounded-t-[8rem] rounded-b-3xl"
            />
            <span className="absolute bottom-5 left-1/2 -translate-x-1/2 font-accent text-[10px] uppercase tracking-[0.2em] bg-[#1E1614]/85 backdrop-blur px-4 py-2 rounded-full text-[#FAF7F2]/80 whitespace-nowrap">
              Foto: pistacchiodistigliano.it
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
